import { Children, useState } from "react";
import { AddIcon, CourseIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function Courses() {
  const [courseslist, setCourseslist] = useState([
    "[Course Title]",
    "[Course Title]",
    "[Course Title]",
    "[Course Title]",
    "[Course Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Courses</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            courseslist.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/courses/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setCourseslist(() => [...courseslist, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setCourseslist(() =>
                      courseslist.filter((item, findex) => findex !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <CourseIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
